import React from "react";
import { MdDarkMode, MdLightMode } from "react-icons/md";
import useTheme from "../constants/there";

export default function ThemeBtn() {
  const { themeMode, lightTheme, darkTheme } = useTheme();

  const toggleTheme = () => {
    if (themeMode === "light") {
      darkTheme();
    } else {
      lightTheme();
    }
  };

  return (
    <button
      onClick={toggleTheme}
      className='p-2 rounded-md cursor-pointer  dark:bg-[#170f2a] dark:border-[#170f2a]'
    >
      {themeMode === "light" ? (
        <MdDarkMode size={24} className='text-gray-900 cursor-pointer' />
      ) : (
        <MdLightMode size={24} className='text-yellow-400 cursor-pointer' />
      )}
    </button>
  );
}
